import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AccessRule } from '../../auth/types';
import { useAuth } from '../../auth/AuthContext';

interface ProtectedRouteProps {
  requiredOperations?: AccessRule['operations'];
  requiredPermissions?: AccessRule['permissions'];
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  requiredOperations,
  requiredPermissions,
  redirectTo = '/login',
}) => {
  const { isAuthorized, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="py-5 text-center">
        <p>Carregando permissoes...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to={redirectTo}
        state={{ from: location.pathname, message: 'Acesso nao autorizado.' }}
        replace
      />
    );
  }

  if (!isAuthorized({ operations: requiredOperations, permissions: requiredPermissions })) {
    return (
      <Navigate
        to="/forbidden"
        state={{ from: location.pathname, message: 'Acesso nao autorizado.' }}
        replace
      />
    );
  }

  return <Outlet />;
};
